<div class="autocomplete-v3-wrapper">
  <div class="input-container">
    <div class="input-wrapper position-relative">
      <input [ngClass]="{'is-invalid': ngControl?.invalid && ngControl?.touched}"
        #addressInput
        type="text"
        class="form-control form-control-solid autocomplete-v3-input"
        [value]="inputValue"
        [disabled]="disabled"
        [id]="inputId"
        [name]="inputName"
        (input)="onInput($event)"
        (focus)="showDropdown = predictions.length > 0"
        (blur)="onBlur()"
        [placeholder]="placeholder"
        [attr.required]="required ? '' : null"
        style="padding-right: 2.5rem;"
      />
      @if (loading) {
        <div class="spinner" style="position: absolute; right: 0.75rem; top: 50%; transform: translateY(-50%); z-index: 2;"></div>
      }
      @if (inputValue && !loading) {
        <button type="button" class="clear-btn position-absolute" style="right: 0.75rem; top: 50%; transform: translateY(-50%); z-index: 2; cursor: pointer;" (click)="onClear()" aria-label="Clear address input">×</button>
      }
    </div>
  </div>
  @if (showDropdown && predictions.length > 0) {
    <ul #dropdown class="autocomplete-v3-dropdown">
      @for (prediction of predictions; track prediction.place_id) {
        <li
            (mousedown)="onSelectPrediction(prediction)"
            class="autocomplete-v3-option">
          <!-- Address icon added before suggestion text -->
          <div class="d-flex align-items-start">
            <i class="fas fa-map-marker-alt address-icon me-2 mt-1"></i>
            <div class="address-text">
              <span [innerHTML]="prediction.structured_formatting.main_text"></span>
              @if (prediction.structured_formatting.secondary_text) {
                <small class="d-block">{{ prediction.structured_formatting.secondary_text }}</small>
              }
            </div>
          </div>
        </li>
      }
    </ul>
  }
  @if (errorMessage) {
    <div class="autocomplete-v3-error">{{ errorMessage }}</div>
  }
</div>
